(function ($) {
    'use strict';
    
    /**
     * Plugin para aplicação de máscaras de input
     * Versão otimizada com ES6+
     */
    $.fn.mask = function(mask, options) {
        // Permite customização de opções sem perder os padrões
        const defaults = {
            onKeyPress: null,
            reverse: false,
            clearIfNotMatch: false,
            placeholder: ''
        };
        
        const settings = {...defaults, ...options};
        
        return this.each(function() {
            const $el = $(this);
            let lastValue = '';
            let isProcessing = false; // Flag para evitar recursão
            
            // Armazenar dados da máscara no elemento
            $el.data('mask', {
                mask,
                options: settings,
                remove() {
                    $el.off('input.mask blur.mask');
                    $el.removeData('mask');
                },
                getMaskedVal(val) {
                    return applyMask(val || '');
                }
            });
            
            // Função principal para aplicar a máscara
            const applyMask = (value) => {
                // Remover caracteres não numéricos para análise
                const rawValue = value.replace(/\D/g, '');
                
                // Se não houver dígitos, retorna string vazia
                if (rawValue.length === 0) {
                    return '';
                }
                
                // Obtém o padrão de máscara (pode ser função ou string fixa)
                const maskPattern = typeof mask === 'function' ? 
                    mask(rawValue) : mask;
                
                // Verificar se precisa limitar a quantidade de dígitos
                const translation = {
                    '0': {pattern: /\d/},
                    '9': {pattern: /\d/, optional: true},
                    '#': {pattern: /\d/, recursive: true},
                    'A': {pattern: /[a-zA-Z0-9]/},
                    'S': {pattern: /[a-zA-Z]/}
                };
                
                let result = '';
                let maskDigitCount = 0;
                let rawDigitIndex = 0;
                
                // Aplicar a máscara caractere por caractere
                for (let i = 0; i < maskPattern.length; i++) {
                    const maskChar = maskPattern[i];
                    const translationObj = translation[maskChar];
                    
                    if (translationObj) {
                        // Se encontrar um caractere que precisa de tradução
                        if (rawDigitIndex < rawValue.length) {
                            const rawChar = rawValue[rawDigitIndex];
                            
                            // Verificar se o caractere corresponde ao padrão
                            if (translationObj.pattern.test(rawChar)) {
                                result += rawChar;
                                rawDigitIndex++;
                            } else {
                                // Caractere não corresponde, tentar próximo
                                rawDigitIndex++;
                                i--; // Repetir este caractere de máscara
                                continue;
                            }
                        } else if (translationObj.optional) {
                            // Sem mais dígitos e o caractere é opcional
                            break;
                        } else if (translationObj.recursive) {
                            // Caractere recursivo
                            // Para simplificar, não implementamos recursão completa
                            break;
                        } else {
                            // Sem mais dígitos e o caractere é obrigatório
                            break;
                        }
                        
                        maskDigitCount++;
                    } else {
                        // Caractere literal na máscara
                        result += maskChar;
                    }
                }
                
                // Verificar se deve limpar em caso de não corresponder
                if (settings.clearIfNotMatch && result.length !== maskPattern.length) {
                    return '';
                }
                
                return result;
            };
            
            // Handler para eventos de input
            const inputHandler = function(e) {
                if (isProcessing) return; // Evitar recursão
                
                try {
                    isProcessing = true;
                    
                    // Obter o valor atual
                    const input = this;
                    const caretPos = getCaretPosition(input);
                    let value = input.value;
                    
                    // Verificar mudanças no valor
                    if (lastValue !== value) {
                        // Aplicar a máscara
                        const maskedValue = applyMask(value);
                        input.value = maskedValue;
                        
                        // Ajustar posição do cursor
                        if (maskedValue !== value) {
                            let newCaretPos = caretPos;
                            
                            // Ajuste inteligente da posição do cursor
                            if (maskedValue.length !== value.length) {
                                // Se estamos adicionando caracteres, move o cursor para frente
                                if (maskedValue.length > value.length) {
                                    const diff = maskedValue.length - value.length;
                                    newCaretPos = Math.min(maskedValue.length, caretPos + diff);
                                } else {
                                    // Se estamos removendo caracteres, ajusta baseado no que foi removido
                                    const valueBeforeCaret = value.substring(0, caretPos);
                                    const digitsBeforeCaret = valueBeforeCaret.replace(/\D/g, '').length;
                                    
                                    // Encontra a posição após o N-ésimo dígito na string formatada
                                    let newPos = 0;
                                    let digitCount = 0;
                                    while (digitCount < digitsBeforeCaret && newPos < maskedValue.length) {
                                        if (/\d/.test(maskedValue.charAt(newPos))) {
                                            digitCount++;
                                        }
                                        newPos++;
                                    }
                                    newCaretPos = newPos;
                                }
                            }
                            
                            // Define a nova posição do cursor
                            setCaretPosition(input, newCaretPos);
                        }
                        
                        lastValue = maskedValue;
                        
                        // Chamar callback onKeyPress se existir, mas sem usar arguments
                        if (settings.onKeyPress && typeof settings.onKeyPress === 'function' && e.type !== 'callback') {
                            settings.onKeyPress.call(this, maskedValue, e, $el, settings);
                        }
                    }
                } catch (err) {
                    console.error('Erro ao aplicar máscara:', err);
                } finally {
                    isProcessing = false;
                }
            };
            
            // Anexar eventos com namespace para facilitar remoção
            $el.off('input.mask blur.mask').on('input.mask blur.mask', inputHandler);
            
            // Aplicar máscara inicial se já tiver valor
            if ($el.val()) {
                inputHandler.call(this, { type: 'callback' });
            }
        });
    };
    
    // Método para remover a máscara
    $.fn.unmask = function() {
        return this.each(function() {
            const $el = $(this);
            const data = $el.data('mask');
            if (data && typeof data.remove === 'function') {
                data.remove();
            } else {
                $el.off('input.mask blur.mask');
                $el.removeData('mask');
            }
        });
    };
    
    // Funções auxiliares para manipulação do cursor
    function getCaretPosition(input) {
        if (!input) return 0;
        if (input.selectionStart !== undefined) {
            return input.selectionStart;
        }
        return 0;
    }
    
    function setCaretPosition(input, pos) {
        if (!input) return;
        if (input.setSelectionRange) {
            input.focus();
            input.setSelectionRange(pos, pos);
        } else if (input.createTextRange) {
            const range = input.createTextRange();
            range.collapse(true);
            range.moveEnd('character', pos);
            range.moveStart('character', pos);
            range.select();
        }
    }
})(jQuery);